import { lighten, darken } from "../style/colorUtils";
// const primaryColor = "#659DBD";

const primaryColor = "#659DBD";

const secondaryColor = "#FBEEC1";

const darkGrey = "#3A3845";
const lightGrey = "#DFDFDE";
const playerColors = [lightGrey, darkGrey];

console.log(lightGrey, darken(lightGrey));
console.log(darkGrey, lighten(darkGrey));

export const theme = {
  primaryColor,
  secondaryColor,
  board: {
    piece: {
      fill: playerColors,
      fillClass: ["light", "dark"],
      stroke: { width: 0.05, colour: "#8D8C92" }, // colour: playerColors.map((c) => darken(c)) },
      kindColor: {
        queen: "#ffc107",
        ant: "#2196f3",
        spider: "#804000",
        beetle: "#9254C8",
        grasshopper: "#4caf50",
      },
    },
  },
};

console.log("theme", theme);
